import React, { useState } from "react";
import PropTypes from "prop-types";
import { Grid, TextField, Box, Typography, MenuItem, Autocomplete } from "@mui/material";
// import { Autocomplete } from "@mui/lab";
import MDTypography from "components/MDTypography";
import { loadPresetCSV } from "../../api/settingsApi";
import PeopleIcon from "@mui/icons-material/People";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import TvIcon from "@mui/icons-material/Tv";
import MovieIcon from "@mui/icons-material/Movie";
import ToysIcon from "@mui/icons-material/Toys";

const PresetDataSelector = ({ setPresetData, setSelectedPreset }) => {
  const [presetCSV, setPresetCSV] = useState(null);

  const presetOptions = [
    {
      label: "HR Dataset",
      value: "hr_dataset.csv",
      description: "A dataset containing human resources information.",
      icon: PeopleIcon,
    },
    {
      label: "Products Dataset",
      value: "Products_Dataset.csv",
      description: "A dataset containing product information.",
      icon: ShoppingCartIcon,
    },
    {
      label: "Automotive Dataset",
      value: "automotive_dataset.csv",
      description: "A dataset containing automotive information.",
      icon: DirectionsCarIcon,
    },
    {
      label: "TV Dataset",
      value: "TV_Dataset_Revised.csv",
      description: "A dataset containing TV information.",
      icon: TvIcon,
    },
    {
      label: "Movie Edits",
      value: "Movie_Edits_3.csv",
      description: "A dataset containing movie edits information.",
      icon: MovieIcon,
    },
    {
      label: "Toy Store Dataset",
      value: "ToyStore_Dataset.csv",
      description: "A dataset containing toy store information.",
      icon: ToysIcon,
    },
  ];

  const handlePresetCSVChange = async (event, newValue) => {
    setPresetCSV(newValue);
    setSelectedPreset(newValue ? newValue.value : "");
    try {
      if (newValue) {
        const data = await loadPresetCSV(newValue.value);
        setPresetData(data);
      } else {
        setPresetData(null);
      }
    } catch (error) {
      console.error("Could not load preset CSV:", error);
    }
  };

  return (
    <Grid item xs={12}>
      <MDTypography variant="h6" gutterBottom>
        Load Preset Data
      </MDTypography>
      <Box sx={{ backgroundColor: "background.paper", borderRadius: "4px", padding: "16px" }}>
        <Autocomplete
          options={presetOptions}
          getOptionLabel={(option) => option.label}
          value={presetCSV}
          onChange={handlePresetCSVChange}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Preset"
              variant="outlined"
              fullWidth
              sx={{
                "& .MuiInputLabel-root": {
                  fontWeight: "bold",
                },
              }}
            />
          )}
          renderOption={(props, option) => (
            <Box component={MenuItem} {...props}>
              <Box display="flex" alignItems="center">
                <option.icon />
                <Box ml={2}>
                  <Typography variant="subtitle1">{option.label}</Typography>
                  <Typography variant="body2" color="textSecondary">
                    {option.description}
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}
        />
      </Box>
    </Grid>
  );
};

PresetDataSelector.propTypes = {
  setPresetData: PropTypes.func.isRequired,
  setSelectedPreset: PropTypes.func.isRequired,
};

export default PresetDataSelector;
